import { UpdateClientInput } from '@app/models/client.model'
import { FetchClubInput } from '@app/models/club.model'
import { UpdateLocationInput } from '@app/models/location.model'

const BODY_FIELDS = `
    ${Object.keys(new UpdateClientInput())
      .filter((key) => key !== 'client_limits')
      .join('\n')}
    api_token
    modules
    slug
    saml_enabled
    saml_entity_id
    saml_idp_url
    saml_cert
    access_hours_policy
    ip_whitelist_enabled
    ip_whitelist
    client_limits {
        max_events
        max_stations
        max_users
        max_requirements
        max_passes_per_event
        max_entrances_per_event
        max_areas_per_event
        max_employee_passes
        max_authorized_passes
        max_vehicle_passes
        max_hme_passes
        max_entrances_per_station_per_month
        max_stations_with_call_groups
        vehicle_hme_daily_reset
    }
`

const CLIENT_LIST_FIELDS = `
    id
    name
    number
    field
    country
    contact
    email
    mobile
    modules
    client_limits {
        max_events
        max_stations
        max_users
        max_requirements
        max_passes_per_event
        max_entrances_per_event
        max_areas_per_event
        max_employee_passes
        max_authorized_passes
        max_vehicle_passes
        max_hme_passes
        max_entrances_per_station_per_month
        max_stations_with_call_groups
        vehicle_hme_daily_reset
    }
`
export function GET_CLIENT(fields: string | null = null) {
  return `query get_client($client_id: Float!) {
    get_client(id: $client_id) {
        success
        errorText
        data {
            ${fields ? fields : BODY_FIELDS}
        }
    }
}
`
}

export const GET_CLIENTS = `
query get_clients($input: GetClientsInput) {
    get_clients(input: $input) {
        success
        errorText
        clients {
            ${CLIENT_LIST_FIELDS}
        }
        pagination {
            currentPage
            totalPages
            totalCount
            itemsPerPage
            hasNextPage
            hasPreviousPage
        }
    }
}
`

export const UPDATE_CLIENT = `
mutation update_client($data: updateClientInput!) {
    update_client(data: $data) {
        success
        errorText
        data {
            ${BODY_FIELDS}
        }
    }
}
`

export const CREATE_CLIENT = `
mutation create_client($data: createClientInput!) {
    create_client(data: $data) {
        success
        errorText
        data {
            ${BODY_FIELDS}
        }
    }
}
`

export const DELETE_CLIENT = `
mutation delete_client($client_id: Float!) {
    delete_client(
        id: $id
    ) {
        success
        errorText
        data {
            id
            name
        }
    }
}
`

export const UPDATE_API_TOKEN = `
mutation update_client_api_token($client_id: Float!) {
    update_client_api_token(
        id: $client_id
    ) {
        success
        errorText
        data {
            api_token
        }
    }
}
`

export const GET_LOCATIONS_AND_CLUB_AREAS = `
id
locations{
    ${Object.keys(new UpdateLocationInput()).join('\n')}    
}
clubs {
    name
    id
    club_areas{
        ${Object.keys(new FetchClubInput()).join('\n')}   
    }
    subscription_types{
        id
        name
    }
}
`
